import script from "./NewsPageSearchSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageSearchSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageSearchSwitcher.vue?vue&type=style&index=0&id=62606bf1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62606bf1"]])

export default __exports__